import React from "react";
import "./animatedHamburger.styles.css";

const AnimatedHamburger = ({ showMenu, setShowMenu }) => {
  return (
    <button
      className={`burger noSelect ${showMenu ? "active" : ""}`}
      onClick={() => setShowMenu(!showMenu)}
      aria-label="Toggle menu"
    ></button>
  );
};

export default AnimatedHamburger;
